module.exports = __webpack_public_path__ + "static/media/pulane.ac5bb7a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/prelogin/public/img/testimonial/pulane.png
// module id = 1237
// module chunks = 0